import { unsafeCSS, type CSSResult } from 'lit';
import toArray from '@loadsmart/miranda-toolset/dist/to-array';

/**
 * Apply standard focus style.
 * @param {string | string[]} selectors
 */
function focusable(selectors: string | string[]): CSSResult {
	return unsafeCSS(
		toArray(selectors)
			.map(
				(selector) =>
					`${selector}:not(.is-disabled, :disabled):focus,
				${selector}:not(.is-disabled, :disabled):focus-within,
				${selector}:not(.is-disabled, :disabled).is-focused`,
			)
			.join(', '),
	);
}

export default focusable;
